export function TimePassingIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12.9698 7.63014C12.7737 9.47211 11.7301 11.1982 10.0031 12.1953C7.13379 13.8519 3.46487 12.8688 1.8083 9.99951L1.63186 9.6939M1.03741 6.36986C1.23347 4.52789 2.27714 2.80179 4.00414 1.80471C6.8734 0.14814 10.5423 1.13122 12.1989 4.00049L12.3753 4.3061M1 11.2811L1.51665 9.35294L3.44483 9.8696M10.5624 4.13037L12.4906 4.64702L13.0073 2.71884M7.00363 3.82405V6.99998L8.76803 8.05863'
        stroke='#6B7280'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
